/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_ActivateInputs */

const cs_action_activate = /** @type {(inputs: Action_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivovat`)
};

const en_action_activate = /** @type {(inputs: Action_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activate`)
};

/**
* | output |
* | --- |
* | "Activate" |
*
* @param {Action_ActivateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const action_activate = /** @type {((inputs?: Action_ActivateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_ActivateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_activate(inputs)
	return cs_action_activate(inputs)
});